import React from 'react';
import { Link } from 'react-router-dom';
import './VideoCard.css';

const getYoutubeThumbnail = (url) => {
    let videoId = "";

    if (url.includes("youtu.be/")) {
        videoId = url.split("youtu.be/")[1]?.split("?")[0];
    } else if (url.includes("youtube.com/watch?v=")) {
        videoId = url.split("v=")[1]?.split("&")[0];
    }
    return videoId ? `https://img.youtube.com/vi/${videoId}/mqdefault.jpg` : "";
};

const VideoCard = ({ id, url, title, index }) => {
    return (
        <Link to={`/video/${id}`} className="video-card">
            <img src={getYoutubeThumbnail(url)} alt={title} />
            <p>{`${index + 1}. ${title}`}</p>
        </Link>
    );
};

export default VideoCard;